<template>
    <b-modal
        id="confirm-delete"
        no-close-on-backdrop
        no-close-on-esc
        hide-header
        hide-footer
        centered
        v-model="modalShow"
    >
        <div class="d-flex flex-column align-items-center justify-center-center my-2">
            <feather-icon
                id="modal-confirm"
                icon="AlertCircleIcon"
                :class="'text-'+type+ ' mb-2'"
                size="80"
            />
            <h3 class="text-center">Tem certeza que deseja {{ actionText }}?</h3>
            <span class="text-center">{{ infoTextModal }}</span>
            <div class="d-flex mt-2">
                <b-button :disabled="loading" variant="primary-button" class="mr-2" @click="cancelAction">
                    {{ textButtonCancel }}
                </b-button>
                <b-button :disabled="loading" :variant="'outline-'+type" @click="confirmAction" >
                    <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                    Sim, {{ actionText }}
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue';
export default {
    components: {
        BModal, BButton
    },

    props: {
        itemIdentifier: {
            required: false,
            type: String
        },
        modalShow: {
            required: true,
            type: Boolean
        },
        typeModal: {
            required: true,
            type: String
        },
        infoText: {
            required: false,
            type: String
        },
        action: {
            required: false,
            type: String
        }
    },

    data() {
        return {
            loading: false,
            textComplement: '',
            modalTypes: [
                {
                    'type': 'success',
                    'action': 'cadastrar',
                    'textButtonCancel': 'Cancelar',
                    'infoText': `${this.$props.itemIdentifier} não terá opção de edição.`
                },
                {
                    'type': 'warning',
                    'action': 'descartar',
                    'textButtonCancel': 'Cancelar',
                    'infoText': `Os dados do item serão perdidos.`
                },
                {
                    'type': 'danger',
                    'action': 'cancelar',
                    'textButtonCancel': 'Continuar editando',
                    'infoText': 'Todos os dados não salvos serão perdidos.'
                }
            ],
            type: '',
            actionText: '',
            textButtonCancel: '',
            infoTextModal: ''
        }
    },

    methods: {
        confirmAction(modalEvent) {
            modalEvent.preventDefault();

            this.loading = true;

            this.$emit('confirmed', modalEvent);
        },

        cancelAction(modalEvent) {
            modalEvent.preventDefault();

            this.$emit('canceled', modalEvent);
        },

        choseText(defaultMesssage) {
            if(this.$props.infoText && typeof this.$props.infoText !== 'string') {
                return this.$props.infoText[this.$props.typeModal];
            }

            return this.$props.infoText ? this.$props.infoText : defaultMesssage;
        },
        choseAction(defaultMesssage) {
            if(this.$props.action && typeof this.$props.action !== 'string') {
                return this.$props.action[this.$props.typeModal];
            }

            return this.$props.action ? this.$props.action : defaultMesssage;
        }
    },

    watch: {
        modalShow() {
            this.loading = false;

            this.modalTypes.map(item => {
                if(item.type == this.$props.typeModal) {
                    this.actionText = this.choseAction(item.action);
                    this.textButtonCancel = item.textButtonCancel;
                    this.infoTextModal = this.choseText(item.infoText);
                    this.type = item.type;
                }
            });
        }
    }
}
</script>

